module.exports = __webpack_public_path__ + "img/logo-recognition.7d21afb5.png";